import { Action } from "../../../actions/actions";
import { AuthActionTypes } from "../actions/actionTypes";
import {cloneDeep} from "lodash";

export interface User {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    is_active: boolean;
    profile_picture: string;
    profile_picture_b64: any;
    profile_picture_base64: any;
    date_joined: string;
    is_superuser: boolean;
    roles?: string[];
    subsidiaries?: [{ id:number, name:string }];
}

const initialState: User[] = [];

export function usersReducer(state = initialState, action: Action) {
    switch (action.type) {
        case AuthActionTypes.GET_USERS_LIST_SUCCESS:
            action.payload.results.map(user=>{

                let _roles_array = cloneDeep(user.roles);

                user.roles.filter((obj, index) => {
                    let find_index =  user.roles.findIndex(o => obj.name === o.name && o.access.length === obj.access.length && JSON.stringify(orderByKey(obj.access)) === JSON.stringify(orderByKey(o.access)));

                    if (index !== find_index) {
                        if ('in' in _roles_array[find_index]) {
                            _roles_array[find_index].in = _roles_array[find_index].in.concat([{
                                id: obj.id,
                                subsidiary: obj.subsidiary.id
                            }])

                        } else {
                            _roles_array[find_index].in = [{
                                id: _roles_array[find_index].id,
                                subsidiary: _roles_array[find_index].subsidiary ? _roles_array[find_index].subsidiary.id : _roles_array[find_index].subsidiary
                            }].concat([{
                                id: obj.id,
                                subsidiary: obj.subsidiary.id
                            }]);
                        }
                        delete _roles_array[index];
                    } else {
                        _roles_array[find_index].in = [{
                            id: _roles_array[find_index].id,
                            subsidiary: _roles_array[find_index].subsidiary ? _roles_array[find_index].subsidiary.id : _roles_array[find_index].subsidiary
                        }]
                    }
                })

                _roles_array.map(role => {
                    role.access.map(a => {
                        a.id = a.resource_entity.id;
                        a.name = a.resource_entity.name
                        delete a.resource_entity
                    });
                    delete role.id;
                    delete role.subsidiary;
                })

                user.roles = _roles_array.filter(p => p)

            })
            return {
                number_of_total_users: action.payload.count,
                users: action.payload.results
            };
        default:
            return state;
    }
}

function* orderByKey(dict) {
    let obj = {};
    let keys = Object.keys(dict).sort();

    keys.forEach(k => {
        if(k=="id" || k=="resource_entity"){
            //delete dict[k]
        }else {
            if (dict[k] && typeof (dict[k]) == 'object') {
                obj[k] = this.orderByKey(dict[k]);
            } else obj[k] = dict[k];
        }
    });
    return obj;
}


export function usersListLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case AuthActionTypes.GET_USERS_LIST:
            return true;

        case AuthActionTypes.GET_USERS_LIST_FAIL:
        case AuthActionTypes.GET_USERS_LIST_SUCCESS:
            return false;

        default:
            return state;
    }
}